import { Typography, type TypographyProps } from '@mui/material';
import type { FC } from 'react';

export const Text: FC<TypographyProps> = ({ children, ...props }) => {
  return (
    <Typography
      {...props}
      sx={{
        color: 'info.main',
        ...props.sx,
      }}
    >
      {children}
    </Typography>
  );
};
